import * as Sentry from '@sentry/react';
import { TUserAdminUI, TUserPropertyManagerUI } from 'data/types/user.types';

const isProd = import.meta.env.REACT_APP_ENVIRONMENT === 'prod';

type TSentryUser = TUserAdminUI | TUserPropertyManagerUI;

export const updateSentryUserContext = (user?: TSentryUser | null, isImpersonated?: boolean) => {
  if (!isProd) {
    return;
  }

  try {
    if (!user) {
      Sentry.setUser(null);
      Sentry.setTag('impersonated', undefined);
      return;
    }

    const { id, email, name, username, phone } = user;

    Sentry.setUser({
      id,
      email,
      name,
      username,
      phone: phone === null || phone === undefined ? undefined : String(phone),
    });

    if (isImpersonated) {
      Sentry.setTag('impersonated', 'true');
    } else {
      Sentry.setTag('impersonated', undefined);
    }
  } catch {
    // Silently fail
  }
};

export const clearSentryUserContext = () => {
  if (!isProd) {
    return;
  }

  try {
    Sentry.setUser(null);
    Sentry.setTag('impersonated', undefined);
  } catch {
    // Silently fail
  }
};
